
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1R4BF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ef529700267c64b8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2rSXm = parcelRequire("2rSXm");

var $jWuk1 = parcelRequire("jWuk1");

var $giAhk = parcelRequire("giAhk");

var $4S6u7 = parcelRequire("4S6u7");

var $lB25E = parcelRequire("lB25E");

var $3aRjT = parcelRequire("3aRjT");
const $ef529700267c64b8$var$CrossIconMedium = (0, $giAhk.injectIntlV2)((props)=>/* @ts-expect-error - 'props.intl' is possibly 'undefined'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
        size: "medium",
        label: props.intl.formatMessage((0, $3aRjT.default).close)
    }));
const $ef529700267c64b8$var$DrawerContent = (props)=>{
    const { onClose: onClose, isAdmin: isAdmin, isOnboarding: isOnboarding, data: data, appEditions: appEditions, methods: methods, onScreenChange: onScreenChange, onPermissionsFetched: onPermissionsFetched, ProjectCreate: ProjectCreate } = props;
    const defaultSelectedTemplateKey = data.defaultSelectedTemplateKey !== undefined ? data.defaultSelectedTemplateKey : (0, $4S6u7.defaultProps).defaultSelectedTemplateKey;
    const isTemplatePickerOpenInitially = data.isTemplatePickerOpenInitially !== undefined ? data.isTemplatePickerOpenInitially : (0, $4S6u7.defaultProps).isTemplatePickerOpenInitially;
    const isImportProjectOpenInitially = data.isImportProjectOpenInitially !== undefined ? data.isImportProjectOpenInitially : (0, $4S6u7.defaultProps).isImportProjectOpenInitially;
    const selectedProjectType = data.selectedProjectType !== undefined ? data.selectedProjectType : (0, $4S6u7.defaultProps).selectedProjectType;
    let source = data.source !== undefined ? data.source : (0, $4S6u7.defaultProps).source;
    // https://softwareteams.atlassian.net/browse/RLSS-4346
    const [originSource] = (0, $lB25E.useQueryParam)('originSource');
    if (!source && originSource !== undefined) source = originSource;
    const drawerOverrides = {
        Sidebar: {
            component: ()=>null
        },
        // @ts-expect-error - TS7006 - Parameter 'styles' implicitly has an 'any' type.
        Content: {
            cssFn: (styles)=>({
                    ...styles,
                    margin: 0
                })
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2rSXm.default), {
        isOpen: data.isOpen,
        width: "full",
        onClose: onClose,
        icon: $ef529700267c64b8$var$CrossIconMedium,
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        overrides: drawerOverrides,
        autoFocusFirstElem: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ProjectCreate, {
        // @ts-expect-error new project create has less props
        isAdmin: isAdmin,
        isOnboarding: isOnboarding,
        isJswOnboarding: false,
        isJiraCoreOnboarding: false,
        skipTemplateSelection: false,
        isNextGen: data.isNextGen,
        showExperienceSelection: data.showExperienceSelection,
        recommendedTemplate: data.recommendedTemplate,
        isConnectedProjectScenario: false,
        defaultSelectedTemplateKey: defaultSelectedTemplateKey,
        isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
        isImportProjectOpenInitially: isImportProjectOpenInitially,
        selectedProjectType: selectedProjectType,
        appEditions: appEditions,
        onCancel: methods.close,
        onSuccess: methods.onSuccess,
        onScreenChange: onScreenChange,
        onPermissionsFetched: onPermissionsFetched,
        source: source,
        onDrawerClose: onClose,
        setOnCloseCallback: methods.setOnCloseCallback,
        onCreateStarted: methods.onCreateStarted,
        recommendationSessionId: data.recommendationSessionId
    }));
};
var $ef529700267c64b8$export$2e2bcd8739ae039 = $ef529700267c64b8$var$DrawerContent;

});
parcelRegister("3aRjT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7095bcaf8c7eb44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d7095bcaf8c7eb44$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    close: {
        "id": "navigation-next.project-create-drawer.close",
        "defaultMessage": "Close"
    }
});

});



//# sourceMappingURL=async-project-create-drawer.6f0bf9b3.js.map
